export const UploadTakebackSVG = (props) => (
  <svg
    width={41}
    height={40}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 31.6667H5H5.5ZM35 25V31.6667H36V25H35ZM35 31.6667C35 32.4181 34.7015 33.1388 34.1701 33.6701L34.8772 34.3772C35.5961 33.6584 36 32.6833 36 31.6667H35ZM34.1701 33.6701C33.6388 34.2015 32.9181 34.5 32.1667 34.5V35.5C33.1833 35.5 34.1584 35.0961 34.8772 34.3772L34.1701 33.6701ZM32.1667 34.5H8.83333V35.5H32.1667V34.5ZM8.83333 34.5C8.08189 34.5 7.36122 34.2015 6.82986 33.6701L6.12276 34.3772C6.84165 35.0961 7.81667 35.5 8.83333 35.5V34.5ZM6.82986 33.6701C6.29851 33.1388 6 32.4181 6 31.6667H5C5 32.6833 5.40387 33.6584 6.12276 34.3772L6.82986 33.6701ZM6 31.6667V25H5V31.6667H6Z"
      fill="white"
    />
    <path
      d="M20.4998 25.0001L20.1463 25.3536C20.3415 25.5489 20.6581 25.5489 20.8534 25.3536L20.4998 25.0001ZM11.813 17.0203L20.1463 25.3536L20.8534 24.6465L12.5201 16.3132L11.813 17.0203ZM20.8534 25.3536L29.1867 17.0203L28.4796 16.3132L20.1463 24.6465L20.8534 25.3536Z"
      fill="white"
    />
    <path d="M21 25V5H20V25H21Z" fill="white" />
  </svg>
);

export const AddMoreSVG = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={20.0002} cy={20.0002} r={16.1667} stroke="white" />
    <path d="M10 20L30 20" stroke="white" />
    <path d="M20 10L20 30" stroke="white" />
  </svg>
);
